export const UPLOAD_URL = "/backend/files";
